import BackgroundImage from '@/assets/landing-page.png'
import PublicAppBar from '@/components/PublicAppBar'
import PublicFooter from '@/components/PublicFooter'
import { CONTAINER_MAX_WIDTH } from '@/config/constants'
import { Box, Button, Flex, Heading, Image, VStack } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'
import { Link } from 'react-router'

/**
 * The public landing page, shown at the root to anyone who isn't signed in. It exists so
 * visitors reach the free-account form instead of being pushed straight into the Auth0
 * login screen, which leaves nobody a way to sign up.
 */
const LandingPage = () => {
  // Hooks
  const { t } = useTranslation()

  return (
    <VStack h="100vh" gap={0} bg="white">
      <PublicAppBar />

      <Box flex="1" w="100%" maxW={CONTAINER_MAX_WIDTH} mx="auto" px="28px" overflow="hidden">
        <Flex position="relative" h="100%">
          <Image src={BackgroundImage} position="absolute" right="0" top="5%" w="80%" alt="" />
          <VStack flex="1" position="relative" align="start" color="secondary.600">
            <VStack w={{ sm: '50%', xl: '55%' }} flex="1" pt="10%" align="start">
              <Heading as="h2" size={{ base: '4xl', md: '5xl' }} lineHeight={1.2} whiteSpace="pre-line">
                {t('hatsuly.landing.headline')}
              </Heading>
              <Button colorPalette="blue" mt={4} asChild data-testid="landing-start">
                <Link to="/register">{t('hatsuly.landing.start')}</Link>
              </Button>
            </VStack>
            <PublicFooter />
          </VStack>
        </Flex>
      </Box>
    </VStack>
  )
}

export default LandingPage
